import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Super Admin is configuration, not live data: it changes only when someone
// changes it here, and every write in lib/api.js invalidates its own key. So
// it is cached until then, and moving between its pages costs nothing. The
// 60s default above would otherwise refetch on the first click after a minute
// of reading — harmless, but pointless traffic on a settings screen.
// `retry: 1` because the default 3 retries with backoff means a broken
// endpoint spins for ~7 seconds before saying so — and a failure is never
// cached, so every click starts that cycle again and the page looks like it
// reloads each time. One retry covers a dropped connection; past that, say
// what went wrong.
queryClient.setQueryDefaults(["superadmin"], { staleTime: Infinity, retry: 1 });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
